module.exports = __webpack_public_path__ + "img/7_32.a57ed320.png";